export default "__VITE_ASSET__D$v6he7L__"